import {XauditModel} from '../../../models/xaudit.model';
import {OperatoryDataModel} from "../../../models/clients/operatory-data.model";

export class AppointmentDataModel extends XauditModel{
// reduced optimised model for scheduler landing page

    AppointmentId: string;
    LOCID: number;

    isReservation: boolean = false;
    Reservation_AppointmentId: string;

    isBlocked: boolean = false;
    enumApptTypeId: string;
    enumApptStatusId: string;
    ApptStatus: string;
    PatientId: string;
    OperatoryId: string;
    secondaryOperatorys: string[] = [];

    PatientName: string;
    ProviderDoctor: string ="";

    ReferringDoctor: string ="";
    LocationName: string ="";

    Label_DoctorId: string;

    Subject: string ="";
    Description: string ="";
    startDate: string;
    endDate: string;
    zstartDate: Date;
    zendDate: Date ;

    isExistingCase: boolean = false;
    PatientCaseId: string;
    CaseWorkItemId: string;

    CaseProcedureId: string;
    ForProcedure: string ="";
    ApptFlags: string;
    PatientFlags: string;
    ProviderDoctor_BackColor: string;
    ProviderDoctor_ForeColor: string;
    AppoitmentType_BackColor: string;
    AppoitmentType_ForeColor: string;
    AppoitmentStatus_BackColor: string;
    AppoitmentStatus_ForeColor: string;
    LabelLine1: string;
    LabelTooltip: string;
    parentAppointmentId: string;
    dataAppoitmentDetails: AppoitmentDetaileModel[] = [];
    PatientFullInfo: string;
}

export class AppoitmentDetaileModel {
    AppointmentId: string;
    AppointmentDetailId: string;
    DetailParameterName: string;
    DetailParameterValue: string;
}

export class xDataAppointmentModel extends XauditModel{
    AppointmentId: string;
    LOCID: number;
    enumApptTypeId: string;
    enumApptStatusId: string;
    PatientId: string;
    OperatoryId: string;
    Label_DoctorId: string;
    Subject: string;
    Description: string;
    startDate: string;
    endDate: string ;
    zstartDate: Date;
    zendDate: Date ;

    Duration: number;
    isAllDay: boolean;
    isFirstVisit: boolean;
    CaseProcedureId: string;
    isExistingCase: boolean;
    PatientCaseId: string;
    CaseWorkItemId: string;
    NoteGroupId: string; // do not use
    ReminderInfo: string;
    RecurrenceInfo: string;
    isReservation: boolean;
    isPastedReschedule: boolean;
    // Front end only
    CaseWorkItemFormsId: string;
    PatientFullInfo: string;
    smsMessage: string = '';
    isDuplicateForSecondaryOps = false;
    parentAppointmentId: string;
    text: string;
}
